import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../../components/APi';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';

function EditCoupon() {
  const [couponCode, setCouponCode] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [couponType, setCouponType] = useState('UNLIMITED');
  const [couponStatus, setCouponStatus] = useState('ACTIVE');
  const [usageLimit, setUsageLimit] = useState(0);
  const [percentage, setPercentage] = useState(50.0);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchCouponDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/coupen/get/${id}`);
        if (response.status === 200) {
          const { coupenCode, expiry_date, coupentype, coupenStatus, usageLimit, percentage } =
            response.data;
          setCouponCode(coupenCode);
          setExpiryDate(expiry_date);
          setCouponType(coupentype);
          setCouponStatus(coupenStatus);
          setUsageLimit(usageLimit);
          setPercentage(percentage);
        } else {
          alert('Failed to fetch coupon details');
        }
      } catch (error) {
        console.error('Error fetching coupon details:', error);
        alert('An error occurred while fetching the coupon details');
      }
    };

    fetchCouponDetails();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = {
      coupenCode: couponCode?.trim(),
      expiry_date: expiryDate,
      coupentype: couponType,
      coupenStatus: couponStatus,
      usageLimit: usageLimit,
      percentage: percentage,
    };

    try {
      const response = await axios.put(`${BASE_URL}/coupen/put/${id}`, params, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        alert('Coupon updated successfully!');
        navigate('/Copuontable/1');
      } else {
        alert('Failed to update coupon');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while updating the coupon');
    }
  };

  const handleCouponTypeChange = (e) => {
    const newCouponType = e.target.value;
    setCouponType(newCouponType);

    if (newCouponType === 'MULTIUSER') {
      setUsageLimit(0);
    }
  };

  return (
    <>
      <Container className=" " style={{ minHeight: '90vh' }}>
        <Card style={{ width: '100%',  margin: '0 auto', boxShadow: '0 8px 32px rgba(0,0,0,0.10)', borderRadius: '24px', border: 'none',  padding: '2rem 1.5rem' }}>
          <div style={{ marginBottom: '1.5rem' }}>
            <Card.Title style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#1e293b', marginBottom: 0 }}>Edit Coupon</Card.Title>
            <Card.Subtitle className="mb-1 text-muted" style={{ fontSize: '1rem' }}>
              Update the coupon details below
            </Card.Subtitle>
          </div>
          <div style={{ marginBottom: '2rem', color: '#64748b', fontSize: '1.05rem' }}>
            Make changes to the coupon and click update to save.
          </div>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="couponCode">
                  <Form.Label>Coupon Code</Form.Label>
                  <Form.Control
                    type="text"
                    value={couponCode}
                    // onChange={(e) => setCouponCode(e.target.value)}
                    required
                     onChange={(e) => {
    const value = e.target.value.replace(/[^A-Za-z0-9-]/g, "");
    setCouponCode(value);
  }}
  pattern="^[A-Za-z0-9-]+$"
  title="Only letters, numbers, and hyphens (-) are allowed."
  placeholder="Allowed: A-Z a-z 0-9 -"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="expiryDate">
                  <Form.Label>Expiry Date</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={expiryDate}
                    onChange={(e) => setExpiryDate(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="couponType">
                  <Form.Label>Coupon Type</Form.Label>
                  <Form.Select value={couponType} onChange={handleCouponTypeChange}>
                    <option value="MULTIUSER">MULTIUSER</option>
                    <option value="UNLIMITED">UNLIMITED</option>
                    <option value="LIMITED">LIMITED</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="couponStatus">
                  <Form.Label>Coupon Status</Form.Label>
                  <Form.Select
                    value={couponStatus}
                    onChange={(e) => setCouponStatus(e.target.value)}
                  >
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="usageLimit">
                  <Form.Label>Usage Limit</Form.Label>
                  <Form.Control
                    type="number"
                    value={usageLimit}
                    onChange={(e) => setUsageLimit(e.target.value)}
                    disabled={couponType === 'MULTIUSER' || couponType === 'UNLIMITED'}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="percentage">
                  <Form.Label>Discount Percentage</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button variant="primary" type="submit">
              Update Coupon
            </Button>
          </Form>
        </Card>
      </Container>
    </>
  );
}

export default EditCoupon;
